var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookMobileReelSound = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 11,
  fill: "none",
  viewBox: "0 0 10 11",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M3.99 8.717V4.439l4.51-.917v2.353A2 2 0 0 0 8 5.81c-1.105 0-2 .93-2 2.075 0 1.147.895 2.076 2 2.076s2-.93 2-2.076V2.667h-.008l.002-.66A2 2 0 0 0 7.596.04L4.097.75a2 2 0 0 0-.771.337 1.5 1.5 0 0 0-.836 1.345V6.91A2 2 0 0 0 2 6.848c-1.105 0-2 .929-2 2.075S.895 11 2 11c1.003 0 1.833-.766 1.978-1.765h.012V9.13a2 2 0 0 0 0-.413"
})));
export default SvgFacebookMobileReelSound;